import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref, Ref } from "vue";

    // define props
    interface Props {
        options?: any
    }
    
export default /*#__PURE__*/_defineComponent({
  props: {
    options: null
  },
  emits: ['intersect'],
  setup(__props: any, { emit }) {

const { options = defaultOptions } = __props as {
        options?: any
    }

    const defaultOptions = {
        root: null,
        threshold: 0,
        rootMargin: '200px',
    }

    
    

    const observeEl: Ref<Element | null> = ref(null);
    let observer: any;

    onMounted(() => {
        observer = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {
                emit('intersect');
            }
        }, options);

        if (observeEl.value === null) {
            return;
        }

        observer.observe(observeEl.value);
    });

    onUnmounted(() => {
        observer.disconnect();
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "observer",
    ref: (_value, _refs) => {
      _refs['observeEl'] = _value
      observeEl.value = _value
    }
  }, null, 512))
}
}

})